<div style="height: 150px; width: 100%; margin: auto">
  <canvas #chartRef></canvas>
</div>
